<template>
    <section class="slider">
        <swiper :spaceBetween="30" :centeredSlides="true" :loop="true" :autoplay="{
            delay: 7000,
            disableOnInteraction: false,
        }" :pagination="{
            clickable: true,
        }" :navigation="true" :modules="modules">
            <swiper-slide v-for="(slider, index) in sliders" :key="index">
                <div class="slider__slides__slide">
                    <img class="slide__image" :src="base_url + slider.file_url" alt="image" />
                </div>
            </swiper-slide>
            <!-- <swiper-slide>
                <div class="slider__slides__slide">
                    <img class="slide__image" src="assets/svg/slidepic.png" alt="image" />
                </div>
            </swiper-slide> -->
        </swiper>
    </section>
</template>
<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';

import 'swiper/css/pagination';
import { Pagination, Autoplay } from 'swiper/modules';
import axios from 'axios';

export default {
    components: {
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            sliders: [],
            base_url: 'https://dashboard.iran-tarabar.ir/',
        }
    },
    methods: {
        getSlider() {
            axios.get(
                "https://core.iran-tarabar.ir/api/slider"
            )
                .then((response) => {
                    this.sliders = response.data;
                    this.$cookies.set("sliders", { data: response.data }, "12h");
                });
        },
    },
    mounted() {
        let sliders = this.$cookies.get("sliders")
            ? this.$cookies.get("sliders")
            : { data: [] };
        if (sliders.data.length > 0) {
            this.sliders = sliders.data;
        } else {
            this.getSlider();
        }
    },
    setup() {
        return {
            modules: [Pagination, Autoplay],
        };
    },

}
</script>
<style scoped>
#app {
    height: 100%;
}

.swiper {
    width: 100%;
    height: 100%;
    z-index: 0
}


.swiper-slide {
    text-align: center;
    font-size: 18px;
    /* background: #fff;/ */

    /* Center slide text vertically */
    display: flex;
    justify-content: center;
    align-items: center;
}

.swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>